import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { useAuth, formatErr } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const next = new URLSearchParams(loc.search).get("next") || "/dashboard";
  const [email, setEmail] = useState(""); const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false); const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { await login(email, pw); toast.success("Welcome back"); nav(next); }
    catch (ex) { setErr(formatErr(ex.response?.data?.detail) || ex.message); }
    finally { setBusy(false); }
  };
  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <>
      <Nav />
      <main className="container-hs py-16 max-w-md">
        <h1 className="font-display text-3xl mb-6">Welcome back</h1>
        <form onSubmit={submit} className="card-hs p-6 space-y-4">
          <div><label className="hs-label">Email</label><input data-testid="login-email" type="email" required className="hs-input" value={email} onChange={e => setEmail(e.target.value)} /></div>
          <div><label className="hs-label">Password</label><input data-testid="login-password" type="password" required className="hs-input" value={pw} onChange={e => setPw(e.target.value)} /></div>
          {err && <div data-testid="login-error" className="text-sm text-brand-danger">{err}</div>}
          <button data-testid="login-submit" disabled={busy} className="btn-primary w-full">{busy ? "Signing in…" : "Log in"}</button>
          <div className="relative py-2 text-center text-xs text-brand-muted">
            <span className="absolute inset-x-0 top-1/2 h-px bg-brand-border" />
            <span className="relative bg-white px-2">or</span>
          </div>
          <button type="button" data-testid="login-google" onClick={google} className="btn-secondary w-full">Continue with Google</button>
          <p className="text-sm text-brand-muted text-center">Don't have an account? <Link to="/register" className="text-brand-accent">Sign up</Link></p>
        </form>
      </main>
      <Footer />
    </>
  );
}
